

export class VehicleLicenseDetailsStatusInput implements IVehicleLicenseDetailsStatusInput {
    /** The auto-generated id of the vehicle license details master */
    vehicleLicenseId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleLicenseDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleLicenseId = _data["vehicleLicenseId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleLicenseDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleLicenseDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleLicenseId"] = this.vehicleLicenseId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleLicenseDetailsStatusInput {
    /** The auto-generated id of the vehicle license details master */
    vehicleLicenseId: number;
    /** The updated status */
    status: number;
}

